/**
 * A constant providing colorscheme values for the (legacy) C2FO theme.
 * @deprecated Use the MUI theme object or the desired theme's palette object
 */
export const Liquidity = {
    colors: {
        primary: {
            deepGreen: '#095540',
            brightGreen: '#6ba43a',
            mediumGreen: '#007f6e',
            brightBlue: '#0095a9', // palette.secondary.light
        },
        supporting: {
            deepBlue: '#005d83',
            grey: '#aca199',
            grey10: '#f6f5f4',
            grey25: '#eae8e6',
            grey50: '#d5d0cc',
            grey75: '#c1b9b3',
        },
        feedback: {
            success: '#04a1c8',
            success10: '#e5f5f9',
            successContrastText: '#024556',
            warning: '#f5a623',
            warning10: '#fef6e9',
            warningContrastText: '#4a320b',
            error: '#bb3100',
            error10: '#f8eae5',
            errorContrastText: '#501500',
            infoContrastText: '#4a4a4a',
        },
        misc: {
            canvas: '#f5f3f2',
            form: '#979797',
            formDisabled: 'rgba(155, 155, 155, 0.45)',
        },
        text: {
            standard: 'rgba(0, 0, 0, 0.7)',
            standardLight: 'rgba(0, 0, 0, 0.54)',
            error: 'rgba(187, 49, 0, 1)',
            inverse: 'rgba(255, 255, 255, 1)',
        },
    },
    measurements: {
        shape: {
            borderRadius: 5, // px
        },
        spacing: 8, // scaling factor in px
    },
};
//# sourceMappingURL=Liquidity.js.map